<script lang="ts">
    import lang from '../../lang/language';
    import { onMount } from 'svelte';
    import serviceStore from '../../store/service';
    import onReqServiceStore from '../../store/oa_service';
    import { getLanguage, getUrlParam } from '../../helpers/url';
    import Details from './Details.svelte';
    import DetailsPlaceholder from './DetailsPlaceholder.svelte';
    import Cart from '../../shared_components/Cart.svelte';
    import LanguageSelector from '../../shared_components/LanguageSelector.svelte';
    import { getListUrl } from '../../helpers/url';
    import Divider from '../../shared_components/Divider.svelte';
    import StickyWishlist from '../../shared_components/wishlist/StickyWishlist.svelte';
    // import { Link } from 'svelte-navigator';
    import { searched } from '../../store/product';
    import { link } from 'svelte-spa-router';

    class ServiceType {}

    let isOnReq;
    let selectedService: ServiceType;
    let services = serviceStore.data;
    let onReqServices = onReqServiceStore.data;

    $: {
        selectedService = isOnReq ? $onReqServices[0] : $services[0];
    }

    onMount(() => {
        window.scrollTo({ top: 0, behavior: 'smooth' });
        if (getUrlParam('on_req') === 'true') {
            onReqServiceStore.search({ Id: getUrlParam('id') });
            isOnReq = true;
            services = onReqServiceStore.data;
        } else if (getUrlParam('on_req') === 'false') {
            serviceStore.search({ Id: getUrlParam('id') });
            isOnReq = false;
            services = serviceStore.data;
        }
        searched.set(false);
    });
</script>

<div class="box">
    <Cart />
    <div class="breadcrumb">
        <div>
            <a href="https://yamatoji.nara-kankou.or.jp/">{lang.home}</a>
            <span class="separator">|</span>
            <a href="?page=list{getLanguage() ? `&lang=${getLanguage()}` : ''}"
                >{lang.list}</a
            >
            <span class="separator">|</span>
            <span>{lang.details}</span>
        </div>
        <div>
            <LanguageSelector />
        </div>
    </div>
    <Divider>
        <div slot="col-1">
            {#if selectedService}
                <Details {selectedService} />
            {:else}
                <DetailsPlaceholder />
            {/if}
        </div>
    </Divider>
</div>
